import React, { useState } from "react";
import makeStyles from '@mui/styles/makeStyles';
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import {
  Box,
  IconButton,
  Modal,
  Slide,
  Typography,
  Paper,
} from "@mui/material";
import { toolbarHeight } from "./ApplicationBar";
import CloseIcon from "@mui/icons-material/Close";
import {
  ABOUT_GIF,
  CONTACT_US,
  PRIVACY_POLICY,
  TERMS_OF_USE,
} from "../../../Common/Constants";

const useStyles = makeStyles((theme) => ({
  appBar: {
    top: "auto",
    bottom: 0,
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: process.env.REACT_APP_TOOLBAR_COLOR || "#FFF",
    color: "black",
    minHeight: toolbarHeight,
  },
  toolBar: {
    minHeight: toolbarHeight,
  },
  grow: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexGrow: 1,
  },
  link: {
    marginLeft: 45,
    cursor: "pointer",
  },
  dialogBar: {
    position: "relative",
    backgroundColor: process.env.REACT_APP_TOOLBAR_COLOR || "#FFF",
    color: "black",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  paper: {
    position: "absolute",
    width: "80%",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #000",
    borderRadius: 10,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    top: `7%`,
    left: `10%`,
    maxHeight: "85%",
    overflowY: "auto",
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
export default function Footer() {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [dialogText, setDialogText] = useState("");
  const [dialogTitle, setDialogTitle] = useState("");
  const links = [
    { label: "Terms Of Use", getText: () => TERMS_OF_USE },
    { label: "Privacy Policy", getText: () => PRIVACY_POLICY },
    { label: "About GIF", getText: () => ABOUT_GIF },
    // { label: "Help", getText: () => lorem },
    { label: "Contact Us", getText: () => CONTACT_US },
  ];

  const handleClose = () => setOpen(false);
  const openDialog = async (button) => {
    const text = (await button?.getText()) || "getText is not implemented";
    setDialogText(text);
    setDialogTitle(button.label);
    setOpen(true);
  };
  return <>
    <AppBar position="fixed" color="primary" className={classes.appBar}>
      <Toolbar className={classes.toolBar}>
        <div className={classes.grow}>
          {links.map((kv) => (
            <Box
              key={kv.label}
              className={classes.link}
              onClick={() => openDialog(kv)}
            >
              <Typography
                component="span"
                variant="subtitle2"
                color="inherit"
                noWrap
              >
                {kv.label}
              </Typography>
            </Box>
          ))}
        </div>
      </Toolbar>
    </AppBar>
    <Modal open={open} onClose={handleClose}>
      <Transition in={open}>
        <Paper className={classes.paper}>
          <AppBar className={classes.dialogBar}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleClose}
                aria-label="close"
                size="large">
                <CloseIcon />
              </IconButton>
              <Typography variant="h6" className={classes.title}>
                {dialogTitle}
              </Typography>
            </Toolbar>
          </AppBar>
          <Typography
            variant="body1"
            style={{ whiteSpace: "pre-line", marginTop: 10 }}
          >
            {dialogText}
          </Typography>
        </Paper>
      </Transition>
    </Modal>
  </>;
}
